function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import e, { useRef as t, useState as i, useEffect as n, useCallback as r, useMemo as s, useLayoutEffect as o, forwardRef as a, useImperativeHandle as u } from "react";
var h = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function c(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var l,
  f = {
    exports: {}
  };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
var m,
  d,
  p,
  v = (l || (l = 1, m = f, function () {
    var e = {}.hasOwnProperty;
    function t() {
      for (var i = [], n = 0; n < arguments.length; n++) {
        var r = arguments[n];
        if (r) {
          var s = typeof r;
          if ("string" === s || "number" === s) i.push(r);else if (Array.isArray(r)) {
            if (r.length) {
              var o = t.apply(null, r);
              o && i.push(o);
            }
          } else if ("object" === s) if (r.toString === Object.prototype.toString) for (var a in r) e.call(r, a) && r[a] && i.push(a);else i.push(r.toString());
        }
      }
      return i.join(" ");
    }
    m.exports ? (t.default = t, m.exports = t) : window.classNames = t;
  }()), f.exports),
  y = c(v);
var b,
  g = c(function () {
    if (p) return d;
    p = 1;
    var e = /^\s+|\s+$/g,
      t = /^[-+]0x[0-9a-f]+$/i,
      i = /^0b[01]+$/i,
      n = /^0o[0-7]+$/i,
      r = parseInt,
      s = Object.prototype.toString;
    function o(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    function a(a) {
      if ("number" == typeof a) return a;
      if (function (e) {
        return "symbol" == typeof e || function (e) {
          return !!e && "object" == typeof e;
        }(e) && "[object Symbol]" == s.call(e);
      }(a)) return NaN;
      if (o(a)) {
        var u = "function" == typeof a.valueOf ? a.valueOf() : a;
        a = o(u) ? u + "" : u;
      }
      if ("string" != typeof a) return 0 === a ? a : +a;
      a = a.replace(e, "");
      var h = i.test(a);
      return h || n.test(a) ? r(a.slice(2), h ? 2 : 8) : t.test(a) ? NaN : +a;
    }
    return d = function (e, t, i) {
      return void 0 === i && (i = t, t = void 0), void 0 !== i && (i = (i = a(i)) == i ? i : 0), void 0 !== t && (t = (t = a(t)) == t ? t : 0), function (e, t, i) {
        return e == e && (void 0 !== i && (e = e <= i ? e : i), void 0 !== t && (e = e >= t ? e : t)), e;
      }(a(e), t, i);
    };
  }()),
  z = {
    exports: {}
  };
var w = (b || (b = 1, function (e, t) {
    var i = "__lodash_hash_undefined__",
      n = 9007199254740991,
      r = "[object Arguments]",
      s = "[object Array]",
      o = "[object Boolean]",
      a = "[object Date]",
      u = "[object Error]",
      c = "[object Function]",
      l = "[object Map]",
      f = "[object Number]",
      m = "[object Object]",
      d = "[object Promise]",
      p = "[object RegExp]",
      v = "[object Set]",
      y = "[object String]",
      b = "[object Symbol]",
      g = "[object WeakMap]",
      z = "[object ArrayBuffer]",
      w = "[object DataView]",
      S = /^\[object .+?Constructor\]$/,
      _ = /^(?:0|[1-9]\d*)$/,
      I = {};
    I["[object Float32Array]"] = I["[object Float64Array]"] = I["[object Int8Array]"] = I["[object Int16Array]"] = I["[object Int32Array]"] = I["[object Uint8Array]"] = I["[object Uint8ClampedArray]"] = I["[object Uint16Array]"] = I["[object Uint32Array]"] = !0, I[r] = I[s] = I[z] = I[o] = I[w] = I[a] = I[u] = I[c] = I[l] = I[f] = I[m] = I[p] = I[v] = I[y] = I[g] = !1;
    var x = "object" == typeof h && h && h.Object === Object && h,
      E = "object" == typeof self && self && self.Object === Object && self,
      V = x || E || Function("return this")(),
      j = t && !t.nodeType && t,
      N = j && e && !e.nodeType && e,
      L = N && N.exports === j,
      O = L && x.process,
      D = function () {
        try {
          return O && O.binding && O.binding("util");
        } catch (e) {}
      }(),
      M = D && D.isTypedArray;
    function P(e, t) {
      for (var i = -1, n = null == e ? 0 : e.length; ++i < n;) if (t(e[i], i, e)) return !0;
      return !1;
    }
    function A(e) {
      var t = -1,
        i = Array(e.size);
      return e.forEach(function (e, n) {
        i[++t] = [n, e];
      }), i;
    }
    function T(e) {
      var t = -1,
        i = Array(e.size);
      return e.forEach(function (e) {
        i[++t] = e;
      }), i;
    }
    var C,
      F,
      k,
      H = Array.prototype,
      $ = Function.prototype,
      Y = Object.prototype,
      B = V["__core-js_shared__"],
      R = $.toString,
      W = Y.hasOwnProperty,
      G = (C = /[^.]+$/.exec(B && B.keys && B.keys.IE_PROTO || "")) ? "Symbol(src)_1." + C : "",
      U = Y.toString,
      X = RegExp("^" + R.call(W).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
      J = L ? V.Buffer : void 0,
      K = V.Symbol,
      Z = V.Uint8Array,
      Q = Y.propertyIsEnumerable,
      q = H.splice,
      ee = K ? K.toStringTag : void 0,
      te = Object.getOwnPropertySymbols,
      ie = J ? J.isBuffer : void 0,
      ne = (F = Object.keys, k = Object, function (e) {
        return F(k(e));
      }),
      re = De(V, "DataView"),
      se = De(V, "Map"),
      oe = De(V, "Promise"),
      ae = De(V, "Set"),
      ue = De(V, "WeakMap"),
      he = De(Object, "create"),
      ce = Te(re),
      le = Te(se),
      fe = Te(oe),
      me = Te(ae),
      de = Te(ue),
      pe = K ? K.prototype : void 0,
      ve = pe ? pe.valueOf : void 0;
    function ye(e) {
      var t = -1,
        i = null == e ? 0 : e.length;
      for (this.clear(); ++t < i;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    function be(e) {
      var t = -1,
        i = null == e ? 0 : e.length;
      for (this.clear(); ++t < i;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    function ge(e) {
      var t = -1,
        i = null == e ? 0 : e.length;
      for (this.clear(); ++t < i;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    function ze(e) {
      var t = -1,
        i = null == e ? 0 : e.length;
      for (this.__data__ = new ge(); ++t < i;) this.add(e[t]);
    }
    function we(e) {
      var t = this.__data__ = new be(e);
      this.size = t.size;
    }
    function Se(e, t) {
      var i = ke(e),
        n = !i && Fe(e),
        r = !i && !n && He(e),
        s = !i && !n && !r && We(e),
        o = i || n || r || s,
        a = o ? function (e, t) {
          for (var i = -1, n = Array(e); ++i < e;) n[i] = t(i);
          return n;
        }(e.length, String) : [],
        u = a.length;
      for (var h in e) !W.call(e, h) || o && ("length" == h || r && ("offset" == h || "parent" == h) || s && ("buffer" == h || "byteLength" == h || "byteOffset" == h) || Ae(h, u)) || a.push(h);
      return a;
    }
    function _e(e, t) {
      for (var i = e.length; i--;) if (Ce(e[i][0], t)) return i;
      return -1;
    }
    function Ie(e) {
      return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : ee && ee in Object(e) ? function (e) {
        var t = W.call(e, ee),
          i = e[ee];
        try {
          e[ee] = void 0;
          var n = !0;
        } catch (e) {}
        var r = U.call(e);
        return n && (t ? e[ee] = i : delete e[ee]), r;
      }(e) : function (e) {
        return U.call(e);
      }(e);
    }
    function xe(e) {
      return Re(e) && Ie(e) == r;
    }
    function Ee(e, t, i, n, h) {
      return e === t || (null == e || null == t || !Re(e) && !Re(t) ? e != e && t != t : function (e, t, i, n, h, c) {
        var d = ke(e),
          g = ke(t),
          S = d ? s : Pe(e),
          _ = g ? s : Pe(t),
          I = (S = S == r ? m : S) == m,
          x = (_ = _ == r ? m : _) == m,
          E = S == _;
        if (E && He(e)) {
          if (!He(t)) return !1;
          d = !0, I = !1;
        }
        if (E && !I) return c || (c = new we()), d || We(e) ? Ne(e, t, i, n, h, c) : function (e, t, i, n, r, s, h) {
          switch (i) {
            case w:
              if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
              e = e.buffer, t = t.buffer;
            case z:
              return !(e.byteLength != t.byteLength || !s(new Z(e), new Z(t)));
            case o:
            case a:
            case f:
              return Ce(+e, +t);
            case u:
              return e.name == t.name && e.message == t.message;
            case p:
            case y:
              return e == t + "";
            case l:
              var c = A;
            case v:
              var m = 1 & n;
              if (c || (c = T), e.size != t.size && !m) return !1;
              var d = h.get(e);
              if (d) return d == t;
              n |= 2, h.set(e, t);
              var g = Ne(c(e), c(t), n, r, s, h);
              return h.delete(e), g;
            case b:
              if (ve) return ve.call(e) == ve.call(t);
          }
          return !1;
        }(e, t, S, i, n, h, c);
        if (!(1 & i)) {
          var V = I && W.call(e, "__wrapped__"),
            j = x && W.call(t, "__wrapped__");
          if (V || j) {
            var N = V ? e.value() : e,
              L = j ? t.value() : t;
            return c || (c = new we()), h(N, L, i, n, c);
          }
        }
        return !!E && (c || (c = new we()), function (e, t, i, n, r, s) {
          var o = 1 & i,
            a = Le(e),
            u = a.length,
            h = Le(t),
            c = h.length;
          if (u != c && !o) return !1;
          for (var l = u; l--;) {
            var f = a[l];
            if (!(o ? f in t : W.call(t, f))) return !1;
          }
          var m = s.get(e);
          if (m && s.get(t)) return m == t;
          var d = !0;
          s.set(e, t), s.set(t, e);
          for (var p = o; ++l < u;) {
            var v = e[f = a[l]],
              y = t[f];
            if (n) var b = o ? n(y, v, f, t, e, s) : n(v, y, f, e, t, s);
            if (!(void 0 === b ? v === y || r(v, y, i, n, s) : b)) {
              d = !1;
              break;
            }
            p || (p = "constructor" == f);
          }
          if (d && !p) {
            var g = e.constructor,
              z = t.constructor;
            g == z || !("constructor" in e) || !("constructor" in t) || "function" == typeof g && g instanceof g && "function" == typeof z && z instanceof z || (d = !1);
          }
          return s.delete(e), s.delete(t), d;
        }(e, t, i, n, h, c));
      }(e, t, i, n, Ee, h));
    }
    function Ve(e) {
      return !(!Be(e) || function (e) {
        return !!G && G in e;
      }(e)) && ($e(e) ? X : S).test(Te(e));
    }
    function je(e) {
      if (i = (t = e) && t.constructor, n = "function" == typeof i && i.prototype || Y, t !== n) return ne(e);
      var t,
        i,
        n,
        r = [];
      for (var s in Object(e)) W.call(e, s) && "constructor" != s && r.push(s);
      return r;
    }
    function Ne(e, t, i, n, r, s) {
      var o = 1 & i,
        a = e.length,
        u = t.length;
      if (a != u && !(o && u > a)) return !1;
      var h = s.get(e);
      if (h && s.get(t)) return h == t;
      var c = -1,
        l = !0,
        f = 2 & i ? new ze() : void 0;
      for (s.set(e, t), s.set(t, e); ++c < a;) {
        var m = e[c],
          d = t[c];
        if (n) var p = o ? n(d, m, c, t, e, s) : n(m, d, c, e, t, s);
        if (void 0 !== p) {
          if (p) continue;
          l = !1;
          break;
        }
        if (f) {
          if (!P(t, function (e, t) {
            if (o = t, !f.has(o) && (m === e || r(m, e, i, n, s))) return f.push(t);
            var o;
          })) {
            l = !1;
            break;
          }
        } else if (m !== d && !r(m, d, i, n, s)) {
          l = !1;
          break;
        }
      }
      return s.delete(e), s.delete(t), l;
    }
    function Le(e) {
      return function (e, t, i) {
        var n = t(e);
        return ke(e) ? n : function (e, t) {
          for (var i = -1, n = t.length, r = e.length; ++i < n;) e[r + i] = t[i];
          return e;
        }(n, i(e));
      }(e, Ge, Me);
    }
    function Oe(e, t) {
      var i,
        n,
        r = e.__data__;
      return ("string" == (n = typeof (i = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== i : null === i) ? r["string" == typeof t ? "string" : "hash"] : r.map;
    }
    function De(e, t) {
      var i = function (e, t) {
        return null == e ? void 0 : e[t];
      }(e, t);
      return Ve(i) ? i : void 0;
    }
    ye.prototype.clear = function () {
      this.__data__ = he ? he(null) : {}, this.size = 0;
    }, ye.prototype.delete = function (e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    }, ye.prototype.get = function (e) {
      var t = this.__data__;
      if (he) {
        var n = t[e];
        return n === i ? void 0 : n;
      }
      return W.call(t, e) ? t[e] : void 0;
    }, ye.prototype.has = function (e) {
      var t = this.__data__;
      return he ? void 0 !== t[e] : W.call(t, e);
    }, ye.prototype.set = function (e, t) {
      var n = this.__data__;
      return this.size += this.has(e) ? 0 : 1, n[e] = he && void 0 === t ? i : t, this;
    }, be.prototype.clear = function () {
      this.__data__ = [], this.size = 0;
    }, be.prototype.delete = function (e) {
      var t = this.__data__,
        i = _e(t, e);
      return !(i < 0 || (i == t.length - 1 ? t.pop() : q.call(t, i, 1), --this.size, 0));
    }, be.prototype.get = function (e) {
      var t = this.__data__,
        i = _e(t, e);
      return i < 0 ? void 0 : t[i][1];
    }, be.prototype.has = function (e) {
      return _e(this.__data__, e) > -1;
    }, be.prototype.set = function (e, t) {
      var i = this.__data__,
        n = _e(i, e);
      return n < 0 ? (++this.size, i.push([e, t])) : i[n][1] = t, this;
    }, ge.prototype.clear = function () {
      this.size = 0, this.__data__ = {
        hash: new ye(),
        map: new (se || be)(),
        string: new ye()
      };
    }, ge.prototype.delete = function (e) {
      var t = Oe(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    }, ge.prototype.get = function (e) {
      return Oe(this, e).get(e);
    }, ge.prototype.has = function (e) {
      return Oe(this, e).has(e);
    }, ge.prototype.set = function (e, t) {
      var i = Oe(this, e),
        n = i.size;
      return i.set(e, t), this.size += i.size == n ? 0 : 1, this;
    }, ze.prototype.add = ze.prototype.push = function (e) {
      return this.__data__.set(e, i), this;
    }, ze.prototype.has = function (e) {
      return this.__data__.has(e);
    }, we.prototype.clear = function () {
      this.__data__ = new be(), this.size = 0;
    }, we.prototype.delete = function (e) {
      var t = this.__data__,
        i = t.delete(e);
      return this.size = t.size, i;
    }, we.prototype.get = function (e) {
      return this.__data__.get(e);
    }, we.prototype.has = function (e) {
      return this.__data__.has(e);
    }, we.prototype.set = function (e, t) {
      var i = this.__data__;
      if (i instanceof be) {
        var n = i.__data__;
        if (!se || n.length < 199) return n.push([e, t]), this.size = ++i.size, this;
        i = this.__data__ = new ge(n);
      }
      return i.set(e, t), this.size = i.size, this;
    };
    var Me = te ? function (e) {
        return null == e ? [] : (e = Object(e), function (e, t) {
          for (var i = -1, n = null == e ? 0 : e.length, r = 0, s = []; ++i < n;) {
            var o = e[i];
            t(o, i, e) && (s[r++] = o);
          }
          return s;
        }(te(e), function (t) {
          return Q.call(e, t);
        }));
      } : function () {
        return [];
      },
      Pe = Ie;
    function Ae(e, t) {
      return !!(t = null == t ? n : t) && ("number" == typeof e || _.test(e)) && e > -1 && e % 1 == 0 && e < t;
    }
    function Te(e) {
      if (null != e) {
        try {
          return R.call(e);
        } catch (e) {}
        try {
          return e + "";
        } catch (e) {}
      }
      return "";
    }
    function Ce(e, t) {
      return e === t || e != e && t != t;
    }
    (re && Pe(new re(new ArrayBuffer(1))) != w || se && Pe(new se()) != l || oe && Pe(oe.resolve()) != d || ae && Pe(new ae()) != v || ue && Pe(new ue()) != g) && (Pe = function (e) {
      var t = Ie(e),
        i = t == m ? e.constructor : void 0,
        n = i ? Te(i) : "";
      if (n) switch (n) {
        case ce:
          return w;
        case le:
          return l;
        case fe:
          return d;
        case me:
          return v;
        case de:
          return g;
      }
      return t;
    });
    var Fe = xe(function () {
        return arguments;
      }()) ? xe : function (e) {
        return Re(e) && W.call(e, "callee") && !Q.call(e, "callee");
      },
      ke = Array.isArray,
      He = ie || function () {
        return !1;
      };
    function $e(e) {
      if (!Be(e)) return !1;
      var t = Ie(e);
      return t == c || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
    }
    function Ye(e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= n;
    }
    function Be(e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    }
    function Re(e) {
      return null != e && "object" == typeof e;
    }
    var We = M ? function (e) {
      return function (t) {
        return e(t);
      };
    }(M) : function (e) {
      return Re(e) && Ye(e.length) && !!I[Ie(e)];
    };
    function Ge(e) {
      return null != (t = e) && Ye(t.length) && !$e(t) ? Se(e) : je(e);
      var t;
    }
    e.exports = function (e, t) {
      return Ee(e, t);
    };
  }(z, z.exports)), z.exports),
  S = c(w);
function _(e, t, i) {
  return e[t] ? e[t][0] ? e[t][0][i] : e[t][i] : "contentBoxSize" === t ? e.contentRect["inlineSize" === i ? "width" : "height"] : void 0;
}
function I(e) {
  void 0 === e && (e = {});
  var o = e.onResize,
    a = t(void 0);
  a.current = o;
  var u = e.round || Math.round,
    h = t(),
    c = i({
      width: void 0,
      height: void 0
    }),
    l = c[0],
    f = c[1],
    m = t(!1);
  n(function () {
    return m.current = !1, function () {
      m.current = !0;
    };
  }, []);
  var d = t({
      width: void 0,
      height: void 0
    }),
    p = function (e, i) {
      var s = t(null),
        o = t(null);
      o.current = i;
      var a = t(null);
      n(function () {
        u();
      });
      var u = r(function () {
        var t = a.current,
          i = o.current,
          n = t || (i ? i instanceof Element ? i : i.current : null);
        s.current && s.current.element === n && s.current.subscriber === e || (s.current && s.current.cleanup && s.current.cleanup(), s.current = {
          element: n,
          subscriber: e,
          cleanup: n ? e(n) : void 0
        });
      }, [e]);
      return n(function () {
        return function () {
          s.current && s.current.cleanup && (s.current.cleanup(), s.current = null);
        };
      }, []), r(function (e) {
        a.current = e, u();
      }, [u]);
    }(r(function (t) {
      return h.current && h.current.box === e.box && h.current.round === u || (h.current = {
        box: e.box,
        round: u,
        instance: new ResizeObserver(function (t) {
          var i = t[0],
            n = "border-box" === e.box ? "borderBoxSize" : "device-pixel-content-box" === e.box ? "devicePixelContentBoxSize" : "contentBoxSize",
            r = _(i, n, "inlineSize"),
            s = _(i, n, "blockSize"),
            o = r ? u(r) : void 0,
            h = s ? u(s) : void 0;
          if (d.current.width !== o || d.current.height !== h) {
            var c = {
              width: o,
              height: h
            };
            d.current.width = o, d.current.height = h, a.current ? a.current(c) : m.current || f(c);
          }
        })
      }), h.current.instance.observe(t, {
        box: e.box
      }), function () {
        h.current && h.current.instance.unobserve(t);
      };
    }, [e.box, u]), e.ref);
  return s(function () {
    return {
      ref: p,
      width: l.width,
      height: l.height
    };
  }, [p, l.width, l.height]);
}
var x = "allotment-module_splitView__L-yRc",
  E = "allotment-module_sashContainer__fzwJF",
  V = "allotment-module_splitViewContainer__rQnVa",
  j = "allotment-module_splitViewView__MGZ6O",
  N = "allotment-module_vertical__WSwwa",
  L = "allotment-module_horizontal__7doS8",
  O = "allotment-module_separatorBorder__x-rDS";
let D,
  M = !1,
  P = !1;
"object" == typeof navigator && (D = navigator.userAgent, P = D.indexOf("Macintosh") >= 0, M = (D.indexOf("Macintosh") >= 0 || D.indexOf("iPad") >= 0 || D.indexOf("iPhone") >= 0) && !!navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
const A = M,
  T = P,
  C = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? o : n;
class F {
  constructor() {
    this._size = void 0;
  }
  getSize() {
    return this._size;
  }
  setSize(e) {
    this._size = e;
  }
}
function k(e, t) {
  const i = e.length,
    n = i - t.length;
  return n >= 0 && e.slice(n, i) === t;
}
var H,
  $ = {
    exports: {}
  };
var Y,
  B,
  R = (H || (H = 1, function (e) {
    var t = Object.prototype.hasOwnProperty,
      i = "~";
    function n() {}
    function r(e, t, i) {
      this.fn = e, this.context = t, this.once = i || !1;
    }
    function s(e, t, n, s, o) {
      if ("function" != typeof n) throw new TypeError("The listener must be a function");
      var a = new r(n, s || e, o),
        u = i ? i + t : t;
      return e._events[u] ? e._events[u].fn ? e._events[u] = [e._events[u], a] : e._events[u].push(a) : (e._events[u] = a, e._eventsCount++), e;
    }
    function o(e, t) {
      0 == --e._eventsCount ? e._events = new n() : delete e._events[t];
    }
    function a() {
      this._events = new n(), this._eventsCount = 0;
    }
    Object.create && (n.prototype = Object.create(null), new n().__proto__ || (i = !1)), a.prototype.eventNames = function () {
      var e,
        n,
        r = [];
      if (0 === this._eventsCount) return r;
      for (n in e = this._events) t.call(e, n) && r.push(i ? n.slice(1) : n);
      return Object.getOwnPropertySymbols ? r.concat(Object.getOwnPropertySymbols(e)) : r;
    }, a.prototype.listeners = function (e) {
      var t = i ? i + e : e,
        n = this._events[t];
      if (!n) return [];
      if (n.fn) return [n.fn];
      for (var r = 0, s = n.length, o = new Array(s); r < s; r++) o[r] = n[r].fn;
      return o;
    }, a.prototype.listenerCount = function (e) {
      var t = i ? i + e : e,
        n = this._events[t];
      return n ? n.fn ? 1 : n.length : 0;
    }, a.prototype.emit = function (e, t, n, r, s, o) {
      var a = i ? i + e : e;
      if (!this._events[a]) return !1;
      var u,
        h,
        c = this._events[a],
        l = arguments.length;
      if (c.fn) {
        switch (c.once && this.removeListener(e, c.fn, void 0, !0), l) {
          case 1:
            return c.fn.call(c.context), !0;
          case 2:
            return c.fn.call(c.context, t), !0;
          case 3:
            return c.fn.call(c.context, t, n), !0;
          case 4:
            return c.fn.call(c.context, t, n, r), !0;
          case 5:
            return c.fn.call(c.context, t, n, r, s), !0;
          case 6:
            return c.fn.call(c.context, t, n, r, s, o), !0;
        }
        for (h = 1, u = new Array(l - 1); h < l; h++) u[h - 1] = arguments[h];
        c.fn.apply(c.context, u);
      } else {
        var f,
          m = c.length;
        for (h = 0; h < m; h++) switch (c[h].once && this.removeListener(e, c[h].fn, void 0, !0), l) {
          case 1:
            c[h].fn.call(c[h].context);
            break;
          case 2:
            c[h].fn.call(c[h].context, t);
            break;
          case 3:
            c[h].fn.call(c[h].context, t, n);
            break;
          case 4:
            c[h].fn.call(c[h].context, t, n, r);
            break;
          default:
            if (!u) for (f = 1, u = new Array(l - 1); f < l; f++) u[f - 1] = arguments[f];
            c[h].fn.apply(c[h].context, u);
        }
      }
      return !0;
    }, a.prototype.on = function (e, t, i) {
      return s(this, e, t, i, !1);
    }, a.prototype.once = function (e, t, i) {
      return s(this, e, t, i, !0);
    }, a.prototype.removeListener = function (e, t, n, r) {
      var s = i ? i + e : e;
      if (!this._events[s]) return this;
      if (!t) return o(this, s), this;
      var a = this._events[s];
      if (a.fn) a.fn !== t || r && !a.once || n && a.context !== n || o(this, s);else {
        for (var u = 0, h = [], c = a.length; u < c; u++) (a[u].fn !== t || r && !a[u].once || n && a[u].context !== n) && h.push(a[u]);
        h.length ? this._events[s] = 1 === h.length ? h[0] : h : o(this, s);
      }
      return this;
    }, a.prototype.removeAllListeners = function (e) {
      var t;
      return e ? (t = i ? i + e : e, this._events[t] && o(this, t)) : (this._events = new n(), this._eventsCount = 0), this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = i, a.EventEmitter = a, e.exports = a;
  }($)), $.exports),
  W = c(R);
function G(e, t) {
  const i = e.indexOf(t);
  i > -1 && (e.splice(i, 1), e.unshift(t));
}
function U(e, t) {
  const i = e.indexOf(t);
  i > -1 && (e.splice(i, 1), e.push(t));
}
function X(e, t, i = 1) {
  const n = Math.max(0, Math.ceil((t - e) / i)),
    r = new Array(n);
  let s = -1;
  for (; ++s < n;) r[s] = e + s * i;
  return r;
}
var J = c(function () {
    if (B) return Y;
    B = 1;
    var e = /^\s+|\s+$/g,
      t = /^[-+]0x[0-9a-f]+$/i,
      i = /^0b[01]+$/i,
      n = /^0o[0-7]+$/i,
      r = parseInt,
      s = "object" == typeof h && h && h.Object === Object && h,
      o = "object" == typeof self && self && self.Object === Object && self,
      a = s || o || Function("return this")(),
      u = Object.prototype.toString,
      c = Math.max,
      l = Math.min,
      f = function f() {
        return a.Date.now();
      };
    function m(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    function d(s) {
      if ("number" == typeof s) return s;
      if (function (e) {
        return "symbol" == typeof e || function (e) {
          return !!e && "object" == typeof e;
        }(e) && "[object Symbol]" == u.call(e);
      }(s)) return NaN;
      if (m(s)) {
        var o = "function" == typeof s.valueOf ? s.valueOf() : s;
        s = m(o) ? o + "" : o;
      }
      if ("string" != typeof s) return 0 === s ? s : +s;
      s = s.replace(e, "");
      var a = i.test(s);
      return a || n.test(s) ? r(s.slice(2), a ? 2 : 8) : t.test(s) ? NaN : +s;
    }
    return Y = function (e, t, i) {
      var n,
        r,
        s,
        o,
        a,
        u,
        h = 0,
        p = !1,
        v = !1,
        y = !0;
      if ("function" != typeof e) throw new TypeError("Expected a function");
      function b(t) {
        var i = n,
          s = r;
        return n = r = void 0, h = t, o = e.apply(s, i);
      }
      function g(e) {
        var i = e - u;
        return void 0 === u || i >= t || i < 0 || v && e - h >= s;
      }
      function z() {
        var e = f();
        if (g(e)) return w(e);
        a = setTimeout(z, function (e) {
          var i = t - (e - u);
          return v ? l(i, s - (e - h)) : i;
        }(e));
      }
      function w(e) {
        return a = void 0, y && n ? b(e) : (n = r = void 0, o);
      }
      function S() {
        var e = f(),
          i = g(e);
        if (n = arguments, r = this, u = e, i) {
          if (void 0 === a) return function (e) {
            return h = e, a = setTimeout(z, t), p ? b(e) : o;
          }(u);
          if (v) return a = setTimeout(z, t), b(u);
        }
        return void 0 === a && (a = setTimeout(z, t)), o;
      }
      return t = d(t) || 0, m(i) && (p = !!i.leading, s = (v = "maxWait" in i) ? c(d(i.maxWait) || 0, t) : s, y = "trailing" in i ? !!i.trailing : y), S.cancel = function () {
        void 0 !== a && clearTimeout(a), h = 0, n = u = r = a = void 0;
      }, S.flush = function () {
        return void 0 === a ? o : w(f());
      }, S;
    };
  }()),
  K = "sash-module_sash__K-9lB",
  Z = "sash-module_disabled__Hm-wx",
  Q = "sash-module_mac__Jf6OJ",
  q = "sash-module_vertical__pB-rs",
  ee = "sash-module_minimum__-UKxp",
  te = "sash-module_maximum__TCWxD",
  ie = "sash-module_horizontal__kFbiw",
  ne = "sash-module_hover__80W6I",
  re = "sash-module_active__bJspD";
let se = function (e) {
    return e.Vertical = "VERTICAL", e.Horizontal = "HORIZONTAL", e;
  }({}),
  oe = function (e) {
    return e.Disabled = "DISABLED", e.Minimum = "MINIMUM", e.Maximum = "MAXIMUM", e.Enabled = "ENABLED", e;
  }({}),
  ae = A ? 20 : 8;
const ue = new W();
class he extends W {
  get state() {
    return this._state;
  }
  set state(e) {
    this._state !== e && (this.el.classList.toggle(Z, e === oe.Disabled), this.el.classList.toggle("sash-disabled", e === oe.Disabled), this.el.classList.toggle(ee, e === oe.Minimum), this.el.classList.toggle("sash-minimum", e === oe.Minimum), this.el.classList.toggle(te, e === oe.Maximum), this.el.classList.toggle("sash-maximum", e === oe.Maximum), this._state = e, this.emit("enablementChange", e));
  }
  constructor(e, t, i) {
    var _i$orientation;
    super(), this.el = void 0, this.layoutProvider = void 0, this.orientation = void 0, this.size = void 0, this.hoverDelay = 300, this.hoverDelayer = J(e => e.classList.add("sash-hover", ne), this.hoverDelay), this._state = oe.Enabled, this.onPointerStart = e => {
      const t = e.pageX,
        i = e.pageY,
        n = {
          startX: t,
          currentX: t,
          startY: i,
          currentY: i
        };
      this.el.classList.add("sash-active", re), this.emit("start", n), this.el.setPointerCapture(e.pointerId);
      const r = e => {
          e.preventDefault();
          const n = {
            startX: t,
            currentX: e.pageX,
            startY: i,
            currentY: e.pageY
          };
          this.emit("change", n);
        },
        s = e => {
          e.preventDefault(), this.el.classList.remove("sash-active", re), this.hoverDelayer.cancel(), this.emit("end"), this.el.releasePointerCapture(e.pointerId), window.removeEventListener("pointermove", r), window.removeEventListener("pointerup", s);
        };
      window.addEventListener("pointermove", r), window.addEventListener("pointerup", s);
    }, this.onPointerDoublePress = () => {
      this.emit("reset");
    }, this.onMouseEnter = () => {
      this.el.classList.contains(re) ? (this.hoverDelayer.cancel(), this.el.classList.add("sash-hover", ne)) : this.hoverDelayer(this.el);
    }, this.onMouseLeave = () => {
      this.hoverDelayer.cancel(), this.el.classList.remove("sash-hover", ne);
    }, this.el = document.createElement("div"), this.el.classList.add("sash", K), this.el.dataset.testid = "sash", e.append(this.el), T && this.el.classList.add("sash-mac", Q), this.el.addEventListener("pointerdown", this.onPointerStart), this.el.addEventListener("dblclick", this.onPointerDoublePress), this.el.addEventListener("mouseenter", this.onMouseEnter), this.el.addEventListener("mouseleave", this.onMouseLeave), "number" == typeof i.size ? (this.size = i.size, i.orientation === se.Vertical ? this.el.style.width = `${this.size}px` : this.el.style.height = `${this.size}px`) : (this.size = ae, ue.on("onDidChangeGlobalSize", e => {
      this.size = e, this.layout();
    })), this.layoutProvider = t, this.orientation = (_i$orientation = i.orientation) != null ? _i$orientation : se.Vertical, this.orientation === se.Horizontal ? (this.el.classList.add("sash-horizontal", ie), this.el.classList.remove("sash-vertical", q)) : (this.el.classList.remove("sash-horizontal", ie), this.el.classList.add("sash-vertical", q)), this.layout();
  }
  layout() {
    if (this.orientation === se.Vertical) {
      const e = this.layoutProvider;
      this.el.style.left = e.getVerticalSashLeft(this) - this.size / 2 + "px", e.getVerticalSashTop && (this.el.style.top = e.getVerticalSashTop(this) + "px"), e.getVerticalSashHeight && (this.el.style.height = e.getVerticalSashHeight(this) + "px");
    } else {
      const e = this.layoutProvider;
      this.el.style.top = e.getHorizontalSashTop(this) - this.size / 2 + "px", e.getHorizontalSashLeft && (this.el.style.left = e.getHorizontalSashLeft(this) + "px"), e.getHorizontalSashWidth && (this.el.style.width = e.getHorizontalSashWidth(this) + "px");
    }
  }
  dispose() {
    this.el.removeEventListener("pointerdown", this.onPointerStart), this.el.removeEventListener("dblclick", this.onPointerDoublePress), this.el.removeEventListener("mouseenter", this.onMouseEnter), this.el.removeEventListener("mouseleave", () => this.onMouseLeave), this.el.remove();
  }
}
let ce;
var le;
(le = ce || (ce = {})).Distribute = {
  type: "distribute"
}, le.Split = function (e) {
  return {
    type: "split",
    index: e
  };
}, le.Invisible = function (e) {
  return {
    type: "invisible",
    cachedVisibleSize: e
  };
};
let fe = function (e) {
  return e.Normal = "NORMAL", e.Low = "LOW", e.High = "HIGH", e;
}({});
class me {
  constructor(e, t, i) {
    this.container = void 0, this.view = void 0, this._size = void 0, this._cachedVisibleSize = void 0, this.container = e, this.view = t, this.container.classList.add("split-view-view", j), this.container.dataset.testid = "split-view-view", "number" == typeof i ? (this._size = i, this._cachedVisibleSize = void 0, e.classList.add("split-view-view-visible")) : (this._size = 0, this._cachedVisibleSize = i.cachedVisibleSize);
  }
  set size(e) {
    this._size = e;
  }
  get size() {
    return this._size;
  }
  get priority() {
    return this.view.priority;
  }
  get snap() {
    return !!this.view.snap;
  }
  get cachedVisibleSize() {
    return this._cachedVisibleSize;
  }
  get visible() {
    return void 0 === this._cachedVisibleSize;
  }
  setVisible(e, t) {
    e !== this.visible && (e ? (this.size = g(this._cachedVisibleSize, this.viewMinimumSize, this.viewMaximumSize), this._cachedVisibleSize = void 0) : (this._cachedVisibleSize = "number" == typeof t ? t : this.size, this.size = 0), this.container.classList.toggle("split-view-view-visible", e), this.view.setVisible && this.view.setVisible(e));
  }
  get minimumSize() {
    return this.visible ? this.view.minimumSize : 0;
  }
  get viewMinimumSize() {
    return this.view.minimumSize;
  }
  get maximumSize() {
    return this.visible ? this.view.maximumSize : 0;
  }
  get viewMaximumSize() {
    return this.view.maximumSize;
  }
  set enabled(e) {
    this.container.style.pointerEvents = e ? "" : "none";
  }
  layout(e) {
    this.layoutContainer(e), this.view.layout(this.size, e);
  }
}
class de extends me {
  layoutContainer(e) {
    this.container.style.left = `${e}px`, this.container.style.width = `${this.size}px`;
  }
}
class pe extends me {
  layoutContainer(e) {
    this.container.style.top = `${e}px`, this.container.style.height = `${this.size}px`;
  }
}
class ve extends W {
  get startSnappingEnabled() {
    return this._startSnappingEnabled;
  }
  set startSnappingEnabled(e) {
    this._startSnappingEnabled !== e && (this._startSnappingEnabled = e, this.updateSashEnablement());
  }
  get endSnappingEnabled() {
    return this._endSnappingEnabled;
  }
  set endSnappingEnabled(e) {
    this._endSnappingEnabled !== e && (this._endSnappingEnabled = e, this.updateSashEnablement());
  }
  constructor(e, t = {}, i, n, r) {
    var _t$orientation, _t$proportionalLayout;
    if (super(), this.onDidChange = void 0, this.onDidDragStart = void 0, this.onDidDragEnd = void 0, this.orientation = void 0, this.sashContainer = void 0, this.size = 0, this.contentSize = 0, this.proportions = void 0, this.viewItems = [], this.sashItems = [], this.sashDragState = void 0, this.proportionalLayout = void 0, this.getSashOrthogonalSize = void 0, this._startSnappingEnabled = !0, this._endSnappingEnabled = !0, this.onSashEnd = e => {
      this.emit("sashchange", e), this.saveProportions();
      for (const _e2 of this.viewItems) _e2.enabled = !0;
    }, this.orientation = (_t$orientation = t.orientation) != null ? _t$orientation : se.Vertical, this.proportionalLayout = (_t$proportionalLayout = t.proportionalLayout) != null ? _t$proportionalLayout : !0, this.getSashOrthogonalSize = t.getSashOrthogonalSize, i && (this.onDidChange = i), n && (this.onDidDragStart = n), r && (this.onDidDragEnd = r), this.sashContainer = document.createElement("div"), this.sashContainer.classList.add("sash-container", E), e.prepend(this.sashContainer), t.descriptor) {
      this.size = t.descriptor.size;
      for (const [_e3, _i] of t.descriptor.views.entries()) {
        const _t = _i.size,
          _n = _i.container,
          _r = _i.view;
        this.addView(_n, _r, _t, _e3, !0);
      }
      this.contentSize = this.viewItems.reduce((e, t) => e + t.size, 0), this.saveProportions();
    }
  }
  addView(e, t, i, n = this.viewItems.length, r) {
    let s;
    s = "number" == typeof i ? i : "split" === i.type ? this.getViewSize(i.index) / 2 : "invisible" === i.type ? {
      cachedVisibleSize: i.cachedVisibleSize
    } : t.minimumSize;
    const o = this.orientation === se.Vertical ? new pe(e, t, s) : new de(e, t, s);
    if (this.viewItems.splice(n, 0, o), this.viewItems.length > 1) {
      const _e4 = this.orientation === se.Vertical ? new he(this.sashContainer, {
          getHorizontalSashTop: e => this.getSashPosition(e),
          getHorizontalSashWidth: this.getSashOrthogonalSize
        }, {
          orientation: se.Horizontal
        }) : new he(this.sashContainer, {
          getVerticalSashLeft: e => this.getSashPosition(e),
          getVerticalSashHeight: this.getSashOrthogonalSize
        }, {
          orientation: se.Vertical
        }),
        _t2 = this.orientation === se.Vertical ? t => ({
          sash: _e4,
          start: t.startY,
          current: t.currentY
        }) : t => ({
          sash: _e4,
          start: t.startX,
          current: t.currentX
        });
      _e4.on("start", e => {
        var _this$onDidDragStart;
        this.emit("sashDragStart"), this.onSashStart(_t2(e));
        const i = this.viewItems.map(e => e.size);
        (_this$onDidDragStart = this.onDidDragStart) == null || _this$onDidDragStart.call(this, i);
      }), _e4.on("change", e => this.onSashChange(_t2(e))), _e4.on("end", () => {
        var _this$onDidDragEnd;
        this.emit("sashDragEnd"), this.onSashEnd(this.sashItems.findIndex(t => t.sash === _e4));
        const t = this.viewItems.map(e => e.size);
        (_this$onDidDragEnd = this.onDidDragEnd) == null || _this$onDidDragEnd.call(this, t);
      }), _e4.on("reset", () => {
        const t = this.sashItems.findIndex(t => t.sash === _e4),
          i = X(t, -1, -1),
          n = X(t + 1, this.viewItems.length),
          r = this.findFirstSnapIndex(i),
          s = this.findFirstSnapIndex(n);
        ("number" != typeof r || this.viewItems[r].visible) && ("number" != typeof s || this.viewItems[s].visible) && this.emit("sashreset", t);
      });
      const _i2 = {
        sash: _e4
      };
      this.sashItems.splice(n - 1, 0, _i2);
    }
    r || this.relayout(), r || "number" == typeof i || "distribute" !== i.type || this.distributeViewSizes();
  }
  removeView(e, t) {
    if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
    const i = this.viewItems.splice(e, 1)[0].view;
    if (this.viewItems.length >= 1) {
      const _t3 = Math.max(e - 1, 0);
      this.sashItems.splice(_t3, 1)[0].sash.dispose();
    }
    return this.relayout(), t && "distribute" === t.type && this.distributeViewSizes(), i;
  }
  moveView(e, t, i) {
    const n = this.getViewCachedVisibleSize(t),
      r = void 0 === n ? this.getViewSize(t) : ce.Invisible(n),
      s = this.removeView(t);
    this.addView(e, s, r, i);
  }
  getViewCachedVisibleSize(e) {
    if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
    return this.viewItems[e].cachedVisibleSize;
  }
  layout(e = this.size) {
    const t = Math.max(this.size, this.contentSize);
    if (this.size = e, this.proportions) for (let _t4 = 0; _t4 < this.viewItems.length; _t4++) {
      const i = this.viewItems[_t4];
      i.size = g(Math.round(this.proportions[_t4] * e), i.minimumSize, i.maximumSize);
    } else {
      const i = X(0, this.viewItems.length),
        n = i.filter(e => this.viewItems[e].priority === fe.Low),
        r = i.filter(e => this.viewItems[e].priority === fe.High);
      this.resize(this.viewItems.length - 1, e - t, void 0, n, r);
    }
    this.distributeEmptySpace(), this.layoutViews();
  }
  resizeView(e, t) {
    if (e < 0 || e >= this.viewItems.length) return;
    const i = X(0, this.viewItems.length).filter(t => t !== e),
      n = [...i.filter(e => this.viewItems[e].priority === fe.Low), e],
      r = i.filter(e => this.viewItems[e].priority === fe.High),
      s = this.viewItems[e];
    t = Math.round(t), t = g(t, s.minimumSize, Math.min(s.maximumSize, this.size)), s.size = t, this.relayout(n, r);
  }
  resizeViews(e) {
    for (let t = 0; t < e.length; t++) {
      const i = this.viewItems[t];
      let n = e[t];
      n = Math.round(n), n = g(n, i.minimumSize, Math.min(i.maximumSize, this.size)), i.size = n;
    }
    this.contentSize = this.viewItems.reduce((e, t) => e + t.size, 0), this.saveProportions(), this.layout(this.size);
  }
  getViewSize(e) {
    return e < 0 || e >= this.viewItems.length ? -1 : this.viewItems[e].size;
  }
  isViewVisible(e) {
    if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
    return this.viewItems[e].visible;
  }
  setViewVisible(e, t) {
    if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
    this.viewItems[e].setVisible(t), this.distributeEmptySpace(e), this.layoutViews(), this.saveProportions();
  }
  distributeViewSizes() {
    const e = [];
    let t = 0;
    for (const _i3 of this.viewItems) _i3.maximumSize - _i3.minimumSize > 0 && (e.push(_i3), t += _i3.size);
    const i = Math.floor(t / e.length);
    for (const _t5 of e) _t5.size = g(i, _t5.minimumSize, _t5.maximumSize);
    const n = X(0, this.viewItems.length),
      r = n.filter(e => this.viewItems[e].priority === fe.Low),
      s = n.filter(e => this.viewItems[e].priority === fe.High);
    this.relayout(r, s);
  }
  dispose() {
    this.sashItems.forEach(e => e.sash.dispose()), this.sashItems = [], this.sashContainer.remove();
  }
  relayout(e, t) {
    const i = this.viewItems.reduce((e, t) => e + t.size, 0);
    this.resize(this.viewItems.length - 1, this.size - i, void 0, e, t), this.distributeEmptySpace(), this.layoutViews(), this.saveProportions();
  }
  onSashStart({
    sash: e,
    start: t
  }) {
    const i = this.sashItems.findIndex(t => t.sash === e);
    (e => {
      const t = this.viewItems.map(e => e.size);
      let n,
        r,
        s = Number.NEGATIVE_INFINITY,
        o = Number.POSITIVE_INFINITY;
      const a = X(i, -1, -1),
        u = X(i + 1, this.viewItems.length),
        h = a.reduce((e, i) => e + (this.viewItems[i].minimumSize - t[i]), 0),
        c = a.reduce((e, i) => e + (this.viewItems[i].viewMaximumSize - t[i]), 0),
        l = 0 === u.length ? Number.POSITIVE_INFINITY : u.reduce((e, i) => e + (t[i] - this.viewItems[i].minimumSize), 0),
        f = 0 === u.length ? Number.NEGATIVE_INFINITY : u.reduce((e, i) => e + (t[i] - this.viewItems[i].viewMaximumSize), 0);
      s = Math.max(h, f), o = Math.min(l, c);
      const m = this.findFirstSnapIndex(a),
        d = this.findFirstSnapIndex(u);
      if ("number" == typeof m) {
        const _e5 = this.viewItems[m],
          _t6 = Math.floor(_e5.viewMinimumSize / 2);
        n = {
          index: m,
          limitDelta: _e5.visible ? s - _t6 : s + _t6,
          size: _e5.size
        };
      }
      if ("number" == typeof d) {
        const _e6 = this.viewItems[d],
          _t7 = Math.floor(_e6.viewMinimumSize / 2);
        r = {
          index: d,
          limitDelta: _e6.visible ? o + _t7 : o - _t7,
          size: _e6.size
        };
      }
      this.sashDragState = {
        start: e,
        current: e,
        index: i,
        sizes: t,
        minDelta: s,
        maxDelta: o,
        snapBefore: n,
        snapAfter: r
      };
    })(t);
  }
  onSashChange({
    current: e
  }) {
    const {
      index: t,
      start: i,
      sizes: n,
      minDelta: r,
      maxDelta: s,
      snapBefore: o,
      snapAfter: a
    } = this.sashDragState;
    this.sashDragState.current = e;
    const u = e - i;
    this.resize(t, u, n, void 0, void 0, r, s, o, a), this.distributeEmptySpace(), this.layoutViews();
  }
  getSashPosition(e) {
    let t = 0;
    for (let i = 0; i < this.sashItems.length; i++) if (t += this.viewItems[i].size, this.sashItems[i].sash === e) return t;
    return 0;
  }
  resize(e, t, i = this.viewItems.map(e => e.size), n, r, s = Number.NEGATIVE_INFINITY, o = Number.POSITIVE_INFINITY, a, u) {
    if (e < 0 || e >= this.viewItems.length) return 0;
    const h = X(e, -1, -1),
      c = X(e + 1, this.viewItems.length);
    if (r) for (const _e7 of r) G(h, _e7), G(c, _e7);
    if (n) for (const _e8 of n) U(h, _e8), U(c, _e8);
    const l = h.map(e => this.viewItems[e]),
      f = h.map(e => i[e]),
      m = c.map(e => this.viewItems[e]),
      d = c.map(e => i[e]),
      p = h.reduce((e, t) => e + (this.viewItems[t].minimumSize - i[t]), 0),
      v = h.reduce((e, t) => e + (this.viewItems[t].maximumSize - i[t]), 0),
      y = 0 === c.length ? Number.POSITIVE_INFINITY : c.reduce((e, t) => e + (i[t] - this.viewItems[t].minimumSize), 0),
      b = 0 === c.length ? Number.NEGATIVE_INFINITY : c.reduce((e, t) => e + (i[t] - this.viewItems[t].maximumSize), 0),
      z = Math.max(p, b, s),
      w = Math.min(y, v, o);
    let S = !1;
    if (a) {
      const _e9 = this.viewItems[a.index],
        _i4 = t >= a.limitDelta;
      S = _i4 !== _e9.visible, _e9.setVisible(_i4, a.size);
    }
    if (!S && u) {
      const _e0 = this.viewItems[u.index],
        _i5 = t < u.limitDelta;
      S = _i5 !== _e0.visible, _e0.setVisible(_i5, u.size);
    }
    if (S) return this.resize(e, t, i, n, r, s, o);
    for (let _e1 = 0, _i6 = t = g(t, z, w); _e1 < l.length; _e1++) {
      const _t8 = l[_e1],
        _n2 = g(f[_e1] + _i6, _t8.minimumSize, _t8.maximumSize);
      _i6 -= _n2 - f[_e1], _t8.size = _n2;
    }
    for (let _e10 = 0, _i7 = t; _e10 < m.length; _e10++) {
      const _t9 = m[_e10],
        _n3 = g(d[_e10] - _i7, _t9.minimumSize, _t9.maximumSize);
      _i7 += _n3 - d[_e10], _t9.size = _n3;
    }
    return t;
  }
  distributeEmptySpace(e) {
    const t = this.viewItems.reduce((e, t) => e + t.size, 0);
    let i = this.size - t;
    const n = X(0, this.viewItems.length),
      r = [],
      s = n.filter(e => this.viewItems[e].priority === fe.Low),
      o = n.filter(e => this.viewItems[e].priority === fe.Normal),
      a = n.filter(e => this.viewItems[e].priority === fe.High);
    r.push(...a, ...o, ...s), "number" == typeof e && U(r, e);
    for (let _e11 = 0; 0 !== i && _e11 < r.length; _e11++) {
      const _t0 = this.viewItems[r[_e11]],
        _n4 = g(_t0.size + i, _t0.minimumSize, _t0.maximumSize);
      i -= _n4 - _t0.size, _t0.size = _n4;
    }
  }
  layoutViews() {
    var _this$onDidChange;
    this.contentSize = this.viewItems.reduce((e, t) => e + t.size, 0);
    let e = 0;
    for (const t of this.viewItems) t.layout(e), e += t.size;
    (_this$onDidChange = this.onDidChange) != null && _this$onDidChange.call(this, this.viewItems.map(e => e.size)), this.sashItems.forEach(e => e.sash.layout()), this.updateSashEnablement();
  }
  saveProportions() {
    this.proportionalLayout && this.contentSize > 0 && (this.proportions = this.viewItems.map(e => e.size / this.contentSize));
  }
  updateSashEnablement() {
    let e = !1;
    const t = this.viewItems.map(t => e = t.size - t.minimumSize > 0 || e);
    e = !1;
    const i = this.viewItems.map(t => e = t.maximumSize - t.size > 0 || e),
      n = [...this.viewItems].reverse();
    e = !1;
    const r = n.map(t => e = t.size - t.minimumSize > 0 || e).reverse();
    e = !1;
    const s = n.map(t => e = t.maximumSize - t.size > 0 || e).reverse();
    let o = 0;
    for (let _e12 = 0; _e12 < this.sashItems.length; _e12++) {
      const {
        sash: _n5
      } = this.sashItems[_e12];
      o += this.viewItems[_e12].size;
      const a = !(t[_e12] && s[_e12 + 1]),
        u = !(i[_e12] && r[_e12 + 1]);
      if (a && u) {
        const _i8 = X(_e12, -1, -1),
          _s = X(_e12 + 1, this.viewItems.length),
          _a = this.findFirstSnapIndex(_i8),
          _u = this.findFirstSnapIndex(_s),
          h = "number" == typeof _a && !this.viewItems[_a].visible,
          c = "number" == typeof _u && !this.viewItems[_u].visible;
        h && r[_e12] && (o > 0 || this.startSnappingEnabled) ? _n5.state = oe.Minimum : c && t[_e12] && (o < this.contentSize || this.endSnappingEnabled) ? _n5.state = oe.Maximum : _n5.state = oe.Disabled;
      } else _n5.state = a && !u ? oe.Minimum : !a && u ? oe.Maximum : oe.Enabled;
    }
  }
  findFirstSnapIndex(e) {
    for (const t of e) {
      const _e13 = this.viewItems[t];
      if (_e13.visible && _e13.snap) return t;
    }
    for (const t of e) {
      const _e14 = this.viewItems[t];
      if (_e14.visible && _e14.maximumSize - _e14.minimumSize > 0) return;
      if (!_e14.visible && _e14.snap) return t;
    }
  }
}
class ye {
  constructor(e) {
    this.size = void 0, this.size = e;
  }
  getPreferredSize() {
    return this.size;
  }
}
class be {
  constructor(e, t) {
    this.proportion = void 0, this.layoutService = void 0, this.proportion = e, this.layoutService = t;
  }
  getPreferredSize() {
    return this.proportion * this.layoutService.getSize();
  }
}
class ge {
  getPreferredSize() {}
}
class ze {
  get preferredSize() {
    return this.layoutStrategy.getPreferredSize();
  }
  set preferredSize(e) {
    if ("number" == typeof e) this.layoutStrategy = new ye(e);else if ("string" == typeof e) {
      const t = e.trim();
      if (k(t, "%")) {
        const _e15 = Number(t.slice(0, -1)) / 100;
        this.layoutStrategy = new be(_e15, this.layoutService);
      } else if (k(t, "px")) {
        const _e16 = Number(t.slice(0, -2)) / 100;
        this.layoutStrategy = new ye(_e16);
      } else if ("number" == typeof Number.parseFloat(t)) {
        const _e17 = Number.parseFloat(t);
        this.layoutStrategy = new ye(_e17);
      } else this.layoutStrategy = new ge();
    } else this.layoutStrategy = new ge();
  }
  constructor(e, t) {
    var _t$priority;
    if (this.minimumSize = 0, this.maximumSize = Number.POSITIVE_INFINITY, this.element = void 0, this.priority = void 0, this.snap = void 0, this.layoutService = void 0, this.layoutStrategy = void 0, this.layoutService = e, this.element = t.element, this.minimumSize = "number" == typeof t.minimumSize ? t.minimumSize : 30, this.maximumSize = "number" == typeof t.maximumSize ? t.maximumSize : Number.POSITIVE_INFINITY, "number" == typeof t.preferredSize) this.layoutStrategy = new ye(t.preferredSize);else if ("string" == typeof t.preferredSize) {
      const _e18 = t.preferredSize.trim();
      if (k(_e18, "%")) {
        const _t1 = Number(_e18.slice(0, -1)) / 100;
        this.layoutStrategy = new be(_t1, this.layoutService);
      } else if (k(_e18, "px")) {
        const _t10 = Number(_e18.slice(0, -2));
        this.layoutStrategy = new ye(_t10);
      } else if ("number" == typeof Number.parseFloat(_e18)) {
        const _t11 = Number.parseFloat(_e18);
        this.layoutStrategy = new ye(_t11);
      } else this.layoutStrategy = new ge();
    } else this.layoutStrategy = new ge();
    this.priority = (_t$priority = t.priority) != null ? _t$priority : fe.Normal, this.snap = "boolean" == typeof t.snap && t.snap;
  }
  layout(e) {}
}
function we(e) {
  return void 0 !== e.minSize || void 0 !== e.maxSize || void 0 !== e.preferredSize || void 0 !== e.priority || void 0 !== e.visible;
}
const Se = a(({
  className: t,
  children: i
}, n) => e.createElement("div", {
  ref: n,
  className: y("split-view-view", j, t)
}, i));
Se.displayName = "Allotment.Pane";
const _e = a(({
  children: o,
  className: a,
  id: h,
  maxSize: c = 1 / 0,
  minSize: l = 30,
  proportionalLayout: f = !0,
  separator: m = !0,
  sizes: d,
  defaultSizes: p = d,
  snap: v = !1,
  vertical: b = !1,
  onChange: g,
  onReset: z,
  onVisibleChange: w,
  onDragStart: _,
  onDragEnd: E
}, j) => {
  const D = t(null),
    M = t([]),
    P = t(new Map()),
    T = t(null),
    k = t(new Map()),
    H = t(new F()),
    $ = t([]),
    [Y, B] = i(!1);
  "production" !== process.env.NODE_ENV && d && console.warn("Prop sizes is deprecated. Please use defaultSizes instead.");
  const R = s(() => e.Children.toArray(o).filter(e.isValidElement), [o]),
    W = r(e => {
      var _$$current, _T$current;
      const t = (_$$current = $.current) == null ? void 0 : _$$current[e];
      return "number" == typeof (t == null ? void 0 : t.preferredSize) && ((_T$current = T.current) != null && _T$current.resizeView(e, Math.round(t.preferredSize)), !0);
    }, []);
  return u(j, () => ({
    reset: () => {
      if (z) z();else {
        var _T$current2;
        (_T$current2 = T.current) == null || _T$current2.distributeViewSizes();
        for (let e = 0; e < $.current.length; e++) W(e);
      }
    },
    resize: e => {
      var _T$current3;
      (_T$current3 = T.current) == null || _T$current3.resizeViews(e);
    }
  })), C(() => {
    let e = !0;
    p && k.current.size !== p.length && (e = !1, console.warn(`Expected ${p.length} children based on defaultSizes but found ${k.current.size}`)), e && p && (M.current = R.map(e => e.key));
    const t = _extends({
      orientation: b ? se.Vertical : se.Horizontal,
      proportionalLayout: f
    }, e && p && {
      descriptor: {
        size: p.reduce((e, t) => e + t, 0),
        views: p.map((e, t) => {
          var _i$minSize, _i$maxSize, _i$priority, _i$snap;
          const i = P.current.get(M.current[t]),
            n = new ze(H.current, _extends({
              element: document.createElement("div"),
              minimumSize: (_i$minSize = i == null ? void 0 : i.minSize) != null ? _i$minSize : l,
              maximumSize: (_i$maxSize = i == null ? void 0 : i.maxSize) != null ? _i$maxSize : c,
              priority: (_i$priority = i == null ? void 0 : i.priority) != null ? _i$priority : fe.Normal
            }, (i == null ? void 0 : i.preferredSize) && {
              preferredSize: i == null ? void 0 : i.preferredSize
            }, {
              snap: (_i$snap = i == null ? void 0 : i.snap) != null ? _i$snap : v
            }));
          return $.current.push(n), {
            container: [...k.current.values()][t],
            size: e,
            view: n
          };
        })
      }
    });
    T.current = new ve(D.current, t, g, _, E), T.current.on("sashDragStart", () => {
      var _D$current;
      (_D$current = D.current) == null || _D$current.classList.add("split-view-sash-dragging");
    }), T.current.on("sashDragEnd", () => {
      var _D$current2;
      (_D$current2 = D.current) == null || _D$current2.classList.remove("split-view-sash-dragging");
    }), T.current.on("sashchange", e => {
      if (w && T.current) {
        const _e19 = R.map(e => e.key);
        for (let t = 0; t < _e19.length; t++) {
          const i = P.current.get(_e19[t]);
          void 0 !== (i == null ? void 0 : i.visible) && i.visible !== T.current.isViewVisible(t) && w(t, T.current.isViewVisible(t));
        }
      }
    }), T.current.on("sashreset", e => {
      if (z) z();else {
        var _T$current4;
        if (W(e)) return;
        if (W(e + 1)) return;
        (_T$current4 = T.current) == null || _T$current4.distributeViewSizes();
      }
    });
    const i = T.current;
    return () => {
      i.dispose();
    };
  }, []), C(() => {
    if (Y) {
      const e = R.map(e => e.key),
        t = [...M.current],
        i = e.filter(e => !M.current.includes(e)),
        n = e.filter(e => M.current.includes(e)),
        r = M.current.map(t => !e.includes(t));
      for (let _e20 = r.length - 1; _e20 >= 0; _e20--) {
        var _T$current5;
        r[_e20] && ((_T$current5 = T.current) != null && _T$current5.removeView(_e20), t.splice(_e20, 1), $.current.splice(_e20, 1));
      }
      for (const _n6 of i) {
        var _i9$minSize, _i9$maxSize, _i9$priority, _i9$snap, _T$current6;
        const _i9 = P.current.get(_n6),
          _r2 = new ze(H.current, _extends({
            element: document.createElement("div"),
            minimumSize: (_i9$minSize = _i9 == null ? void 0 : _i9.minSize) != null ? _i9$minSize : l,
            maximumSize: (_i9$maxSize = _i9 == null ? void 0 : _i9.maxSize) != null ? _i9$maxSize : c,
            priority: (_i9$priority = _i9 == null ? void 0 : _i9.priority) != null ? _i9$priority : fe.Normal
          }, (_i9 == null ? void 0 : _i9.preferredSize) && {
            preferredSize: _i9 == null ? void 0 : _i9.preferredSize
          }, {
            snap: (_i9$snap = _i9 == null ? void 0 : _i9.snap) != null ? _i9$snap : v
          }));
        (_T$current6 = T.current) != null && _T$current6.addView(k.current.get(_n6), _r2, ce.Distribute, e.findIndex(e => e === _n6)), t.splice(e.findIndex(e => e === _n6), 0, _n6), $.current.splice(e.findIndex(e => e === _n6), 0, _r2);
      }
      for (; !S(e, t);) for (const [_i0, _n7] of e.entries()) {
        const _e21 = t.findIndex(e => e === _n7);
        if (_e21 !== _i0) {
          var _T$current7;
          (_T$current7 = T.current) == null || _T$current7.moveView(k.current.get(_n7), _e21, _i0);
          const _r3 = t[_e21];
          t.splice(_e21, 1), t.splice(_i0, 0, _r3);
          break;
        }
      }
      for (const _t12 of i) {
        var _T$current8;
        const _i1 = e.findIndex(e => e === _t12),
          _n8 = $.current[_i1].preferredSize;
        void 0 !== _n8 && ((_T$current8 = T.current) == null ? void 0 : _T$current8.resizeView(_i1, _n8));
      }
      for (const _t13 of [...i, ...n]) {
        var _T$current9, _T$current0;
        const _i10 = P.current.get(_t13),
          _n9 = e.findIndex(e => e === _t13);
        _i10 && we(_i10) && void 0 !== _i10.visible && ((_T$current9 = T.current) == null ? void 0 : _T$current9.isViewVisible(_n9)) !== _i10.visible && ((_T$current0 = T.current) == null ? void 0 : _T$current0.setViewVisible(_n9, _i10.visible));
      }
      for (const _t14 of n) {
        const _i11 = P.current.get(_t14),
          _n0 = e.findIndex(e => e === _t14);
        if (_i11 && we(_i11)) {
          var _T$current1;
          void 0 !== _i11.preferredSize && $.current[_n0].preferredSize !== _i11.preferredSize && ($.current[_n0].preferredSize = _i11.preferredSize);
          let _e22 = !1;
          void 0 !== _i11.minSize && $.current[_n0].minimumSize !== _i11.minSize && ($.current[_n0].minimumSize = _i11.minSize, _e22 = !0), void 0 !== _i11.maxSize && $.current[_n0].maximumSize !== _i11.maxSize && ($.current[_n0].maximumSize = _i11.maxSize, _e22 = !0), _e22 && ((_T$current1 = T.current) == null ? void 0 : _T$current1.layout());
        }
      }
      (i.length > 0 || r.length > 0) && (M.current = e);
    }
  }, [R, Y, c, l, v]), n(() => {
    T.current && (T.current.onDidChange = g);
  }, [g]), n(() => {
    T.current && (T.current.onDidDragStart = _);
  }, [_]), n(() => {
    T.current && (T.current.onDidDragEnd = E);
  }, [E]), I({
    ref: D,
    onResize: ({
      width: e,
      height: t
    }) => {
      var _T$current10;
      e && t && ((_T$current10 = T.current) != null && _T$current10.layout(b ? t : e), H.current.setSize(b ? t : e), B(!0));
    }
  }), n(() => {
    A && Ie(20);
  }, []), e.createElement("div", {
    ref: D,
    className: y("split-view", b ? "split-view-vertical" : "split-view-horizontal", {
      "split-view-separator-border": m
    }, x, b ? N : L, {
      [O]: m
    }, a),
    id: h
  }, e.createElement("div", {
    className: y("split-view-container", V)
  }, e.Children.toArray(o).map(t => {
    if (!e.isValidElement(t)) return null;
    const i = t.key;
    return "Allotment.Pane" === t.type.displayName ? (P.current.set(i, t.props), e.cloneElement(t, {
      key: i,
      ref: e => {
        const n = t.ref;
        n && (n.current = e), e ? k.current.set(i, e) : k.current.delete(i);
      }
    })) : e.createElement(Se, {
      key: i,
      ref: e => {
        e ? k.current.set(i, e) : k.current.delete(i);
      }
    }, t);
  })));
});
function Ie(e) {
  const t = g(e, 4, 20),
    i = g(e, 1, 8);
  document.documentElement.style.setProperty("--sash-size", t + "px"), document.documentElement.style.setProperty("--sash-hover-size", i + "px"), function (e) {
    ae = e, ue.emit("onDidChangeGlobalSize", e);
  }(t);
}
_e.displayName = "Allotment";
var xe = Object.assign(_e, {
  Pane: Se
});
export { xe as Allotment, fe as LayoutPriority, Ie as setSashSize };
